import React, { useEffect, useState } from "react";
import { CustomerContactsState } from "src/types/CustomerContacts";

import BarChart from "../generic/BarChart";
interface Props {
  customerContacts: CustomerContactsState;
}

const BarChartNbaAcceptedTopTen: React.FC<Props> = ({
  customerContacts,
}: Props) => {
  const [chartData, setChartData] = useState<
    Array<{ x: string; yleft: number }>
  >([]);

  useEffect(() => {
    const offerAddressed =
      customerContacts.countNbaTopTenByOfferAddressed.offerAddressed;
    const offerAccepted =
      customerContacts.countNbaTopTenByOfferAddressed.offerAccepted;
    const chartData = [];
    for (
      let nbaNameIndex = 0;
      nbaNameIndex < offerAddressed.nbaNames.length;
      nbaNameIndex++
    ) {
      chartData.push({
        x: offerAddressed.nbaNames[nbaNameIndex],
        yleft: parseFloat(
          (
            100 *
            (offerAccepted.countArray[nbaNameIndex] /
              offerAddressed.countArray[nbaNameIndex])
          ).toFixed(1)
        ),
        yright: offerAddressed.countArray[nbaNameIndex],
      });
    }
    setChartData(chartData);
  }, [customerContacts]);

  return (
    <BarChart
      data={chartData}
      yLabelLeft="Anteil Angebot angenommen"
      yLabelRight="Anzahl Angebot angeprochen"
      yTicksLeftFormatter={(tick: number) => `${tick}%`}
      tooltipYValueFormatter={(value, dataKey) =>
        dataKey === "yleft" ? `${value}%` : `${value}`
      }
      colorYLeft="#648c64"
      colorYRight="#3c78aa"
      barOpacity={0.7}
    />
  );
};

export default BarChartNbaAcceptedTopTen;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/BarChartNbaAcceptedTopTen.tsx